export type FiStarterPathway = 'stories' | 'listeners' | 'resources' | 'everything';

export type FiStarterAction = {
  title: string;
  subtitle: string;
  hint: string;
  /** Editable draft shown in the input (user completes before sending). */
  draft: string;
  pathway: FiStarterPathway;
};

export const FI_STARTER_ACTIONS: FiStarterAction[] = [
  {
    title: 'View stories',
    subtitle: 'Hear from others with similar experiences',
    hint: 'What kind of stories are you looking for?',
    draft: 'I want stories about ',
    pathway: 'stories',
  },
  {
    title: 'Talk to someone',
    subtitle: 'Connect with a peer listener',
    hint: 'What would you like to talk about?',
    draft: 'I want to talk about ',
    pathway: 'listeners',
  },
  {
    title: 'View resources',
    subtitle: 'Guides, benefits, and tools',
    hint: 'What kind of resources do you need?',
    draft: 'I need resources for ',
    pathway: 'resources',
  },
  {
    title: 'Show me everything',
    subtitle: 'See all options at once',
    hint: 'What would you like to explore today?',
    draft: 'I want to explore ',
    pathway: 'everything',
  },
];

export const FI_OPENING_MESSAGE = "Hi — I'm Fi, your Kindly Human concierge.";

/** Example searches shown in the welcome hero (populate the input on tap). */
export const FI_SUGGESTED_SEARCHES: FiStarterAction[] = [
  {
    title: 'Caregiver burnout stories',
    subtitle: '',
    hint: 'What else would you like to explore?',
    draft: 'Show me stories about caregiver burnout',
    pathway: 'stories',
  },
  {
    title: 'Talk about work stress',
    subtitle: '',
    hint: 'What would you like to talk about?',
    draft: 'I want to talk to someone about work stress',
    pathway: 'listeners',
  },
  {
    title: 'Mental health benefits',
    subtitle: '',
    hint: 'What kind of resources do you need?',
    draft: 'I need resources for mental health benefits',
    pathway: 'resources',
  },
];
